import { getByID } from '@adornis/baseql/operations/mongo.js';
import { XWikiDefaultTemplateEditor } from '@adornis/wiki/client/x-wiki-default-template-editor.js';
import { XWikiDraftListRows } from '@adornis/wiki/client/x-wiki-draft-list-rows.js';
import { XWikiDraftList } from '@adornis/wiki/client/x-wiki-draft-list.js';
import { XWikiEditor } from '@adornis/wiki/client/x-wiki-editor';
import { XWikiFull } from '@adornis/wiki/client/x-wiki-full.js';
import { XWikiUserText } from '@adornis/wiki/client/x-wiki-user-text.js';
import { XWikiView } from '@adornis/wiki/client/x-wiki-view';
import { XWikiSplitterView } from '@adornis/wiki/client/x-wiki-splitter-view.js';
import { cachedUntil } from '@chancenwerk/client/util.js';
import { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-wiki-full
 */
@customElement('cr-wiki-full')
export class ChromiumWikiFull extends XWikiFull {}

/**
 * @customElement cr-wiki-edit
 */
@customElement('cr-wiki-editor')
export class ChromiumWikiEditor extends XWikiEditor {}

/**
 * @customElement cr-wiki-view
 */
@customElement('cr-wiki-view')
export class ChromiumWikiView extends XWikiView {}

/**
 * @customElement cr-wiki-draft-list
 */
@customElement('cr-wiki-draft-list')
export class ChromiumWikiDraftList extends XWikiDraftList {}

/**
 * @customElement cr-wiki-draft-list-rows
 */
@customElement('cr-wiki-draft-list-rows')
export class ChromiumWikiDraftListRows extends XWikiDraftListRows {}

/**
 * @customElement cr-wiki-default-template-editor
 */
@customElement('cr-wiki-default-template-editor')
export class ChromiumWikiDefaultTemplateEditor extends XWikiDefaultTemplateEditor {}

/**
 * @customElement cr-wiki-user-text
 */
@customElement('cr-wiki-user-text')
export class ChromiumWikiUserText extends XWikiUserText {
  override render() {
    if (this.userID.value === '' || !this.userID.value) {
      return '';
    }

    return html`${cachedUntil(
      this.userID.value,
      async () => {
        const user = await getByID(ChancenwerkUser, this.userID.value)({ vorname: 1, nachname: 1, email: 1 });
        return html`(${user?.toString() ?? 'Unbekannter Nutzer'})`;
      },
      html``,
      1000 * 60 * 5,
    )}`;
  }
}

/**
 * @customElement cr-wiki-splitter-view
 */
@customElement('cr-wiki-splitter-view')
export class ChromiumWikiSplitterView extends XWikiSplitterView {}
